let toggles;

export function getToggle(toggleName) {
    if (!toggles) {
        toggles = window.aaalife.config.toggles;
    }

    return toggles[toggleName];
}
